import ScalarIconButton_default from "./ScalarIconButton.vue.js";
export { ScalarIconButton_default as ScalarIconButton };
